import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  Dropdown,
  Menu,
  Badge,
  Space,
  List,
  Avatar,
  Tooltip,
  Divider,
  Grid,
  App,
  Tag,
} from "antd";
import {
  DownOutlined,
  UserOutlined,
  TeamOutlined,
  FileTextOutlined,
  DollarOutlined,
  ScheduleOutlined,
  ApartmentOutlined,
  SettingOutlined,
  BellOutlined,
  SolutionOutlined,
  BankOutlined,
} from "@ant-design/icons";
import PendingRequestsList from "./AttendanceOverview/components/PendingRequestsList"; // optional small widget
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { accessChecker } from "../lib/functions";
import AttendanceCharts from "./HrmsDashboard/AttendanceCharts";
import {
  selectAttendanceReport,
  selectEmployees,
  selectHrLocation,
  checkInStatus,
  selectAttendanceSummary,
} from "./AttendanceOverview/attendanceOverviewSelectors";
import {
  fetchAllEmployees,
  fetchAttendanceReport,
  fetchcheckInStatus,
  fetchPendingRequests,
  fetchTodaySummary,
  markAttendance,
} from "./AttendanceOverview/attendanceOverviewThunk";
import "./HRPayrollDashboard.css";
import { UAParser } from "ua-parser-js";
import MarkAttendanceModal from "./AttendanceOverview/components/modals/MarkAttendanceModal";
import { selectAuthInfo } from "./Auth/authSelectors";
import { loadAllNotifications } from "../store/commonThunks/notificationsThunk";

const { Title, Text } = Typography;



export default function HRPayrollDashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { modal } = App.useApp();
  const authInfo = useSelector(selectAuthInfo);

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [isAdminUser, isAdminUserSet] = useState(false);

  const upcomingExpiries = useSelector((s) => s.notifications.expiryListHR);
  const hrActivities = useSelector((s) => s.notifications.activityListHR);

  const accessList = authInfo?.company_user_access?.map((x) => x.access) || [];

  
  const checkIndata = useSelector(checkInStatus) || {};

  // --- selectors (adapt names to your store) ---
  const attendanceReport = useSelector(selectAttendanceReport);
  const employees = useSelector(selectEmployees);
  const calendarData = useSelector(
    (s) => s.attendanceOverview?.calendarData || {}
  );
  const pendingRequests = useSelector(
    (s) =>
      s.attendanceOverview?.pendingRequests || { pending: [], attendance: [] }
  );   

  const notificationsCount = useSelector((s) => s.notifications?.count || 0);
  const notificationsList = useSelector((s) => s.notifications?.list || []);
  const [userDeviceDetails, setUserDeviceDetails] = useState({});
  const [userDistance, setUserDistance] = useState(null);
  const [branchLocation, setBranchLocation] = useState({});
  const hrLocation = useSelector(selectHrLocation) || {};
  const [userLocation, setUserLocation] = useState({});
  const [markModal, setMarkModal] = useState(false);
  const [disabled, setDisabled] = useState(false);


  // Derive KPIs
  const totalEmployees = employees.length;

  useEffect(() => {
    dispatch(loadAllNotifications({}));
  }, [dispatch]);


  useEffect(() => {
    dispatch(fetchTodaySummary());
    dispatch(fetchPendingRequests());
  }, [dispatch]);

  const attendanceSummary = useSelector(selectAttendanceSummary);
  
  const attendanceNotifications = useSelector((s) => s.notifications?.attendanceListAll || []);


  const presentToday = attendanceSummary.present || 0;
  

  useEffect(() => {
    // if (authInfo.employee_id != null && authInfo.employee_id !== 0) {
    getUserDeviceDetails();
    // getUserLocation();
    setBranchLocation(hrLocation);
    // }
  }, []);

  useEffect(() => {
    if (userLocation.latitude && hrLocation.latitude) {
      const distance = DistanceBetweenTwoLocations(
        userLocation.latitude,
        userLocation.longitude,
        hrLocation.latitude,
        hrLocation.longitude
      );
      setUserDistance(distance);
    }
  }, [userLocation, branchLocation, hrLocation]);

  const DistanceBetweenTwoLocations = (lat1, lon1, lat2, lon2) => {
    const R = 6371000; // Earth radius in meters
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = R * c; // Distance in meters
    return distance;
  };

  const getUserDeviceDetails = async () => {
    const parser = new UAParser();
    const result = parser.getResult();
    const userDeviceDetails = {
      browser: result.browser.name || "Unknown", // e.g., "Chrome"
      os: result.os.name || "Unknown", // e.g., "Windows", "iOS"
      deviceType: result.device.type || "Desktop", // e.g., "Mobile", "Tablet", "Desktop"
    };
    setUserDeviceDetails(userDeviceDetails);
  };

  function formatDistance(meters) {
    const km = Math.floor(meters / 1000);
    const m = (meters % 1000).toFixed(2);
    return `${km} km ${m} m`;
  }

  const approvalsNeeded = useMemo(() => {
    const pend = pendingRequests?.pending || [];
    return pend.length;
  }, [pendingRequests]);

  const leaveToday =
  (attendanceSummary.sick_leave || 0) +
  (attendanceSummary.casual_leave || 0) +
  (attendanceSummary.leave || 0)+
  (attendanceSummary.short_sick_leave || 0)+
  (attendanceSummary.short_casual_leave || 0) +
  (attendanceSummary.short_leave || 0)

  // const approvalsNeeded = useMemo(() => {
  //   const approveArr = (calendarData?.pending || []).filter(
  //     (p) => p.status === "pending"
  //   );
  //   return approveArr.length + (pendingRequests?.pending || []).length;
  // }, [calendarData, pendingRequests]);

  const monthlyAttendanceSummary = useMemo(() => {
    const att = calendarData?.attendance || [];

    let present = 0;
    let absent = 0;
    let leave = 0;

    att.forEach((a) => {
      if (a.attendance === "present") present++;
      if (a.attendance === "absent") absent++;
      if (a.attendance === "leave") leave++;
    });

    return [
      { name: "Present", value: present },
      { name: "Absent", value: absent },
      { name: "Leaves", value: leave },
    ];
  }, [calendarData]);

  const handleMarkAttendance = async (data) => {
    try {
      setDisabled(true);
      dispatch(markAttendance({ action: "present", notes: data.notes }))
        .unwrap()
        .then((res) => modal.success({ title: res.message }))
        .catch((err) => modal.error({ title: err.message }));
      await Promise.all([
        dispatch(fetchcheckInStatus()).unwrap(),
        // dispatch(fetchCalendar()).unwrap(),
      ]);
      setMarkModal(false);
    } catch (err) {
      modal.error({
        title: "Failed to Mark Attendance",
        content: err?.message || "An unexpected error occurred",
      });
    } finally {
      setDisabled(false);
    }
  };
  

  useEffect(() => {
    const startOfMonth = dayjs().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = dayjs().endOf("month").format("YYYY-MM-DD");

    dispatch(fetchAllEmployees());
    dispatch(
      fetchAttendanceReport({
        fromDate: startOfMonth,
        toDate: endOfMonth,
        employee_id: null,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    const hrRoles = [
      // HR role
      "ForthERP_Basic_hr",
      "ForthERP_Standard_hr",
      "ForthERP_Pro_hr",
      "PharmaERP_Basic_hr",
      "PharmaERP_Standard_hr",
      "PharmaERP_Pro_hr",
      "PharmaBooks_Basic_hr",
      "PharmaBooks_Standard_hr",
      "PharmaBooks_Pro_hr",
      "ForthBooks_Basic_hr",
      "ForthBooks_Standard_hr",
      "ForthBooks_Pro_hr",
      "HRPayroll_Standard_hr",
      "HRPayroll_Pro_hr",
      "SuperERP_hr",

      // Admin role
      "ForthERP_Basic_admin",
      "ForthERP_Standard_admin",
      "ForthERP_Pro_admin",
      "PharmaERP_Basic_admin",
      "PharmaERP_Standard_admin",
      "PharmaERP_Pro_admin",
      "PharmaBooks_Basic_admin",
      "PharmaBooks_Standard_admin",
      "PharmaBooks_Pro_admin",
      "ForthBooks_Basic_admin",
      "ForthBooks_Standard_admin",
      "ForthBooks_Pro_admin",
      "HRPayroll_Standard_admin",
      "HRPayroll_Pro_admin",
      "SuperERP_admin",
    ];

    const userRoles = authInfo.userInfo.user_role_names
      ? authInfo.userInfo.user_role_names.split(",").map((role) => role.trim())
      : [];

    const isAdminHR = userRoles.some((role) => hrRoles.includes(role));

    isAdminUserSet(isAdminHR);
  }, []);

  const isEmployee = authInfo?.employee_id && authInfo.employee_id !== 0;

  const previewItems = [
  ...attendanceNotifications.map((a) => ({
    type: "attendance",
    ...a,
  })),
  ...upcomingExpiries.map((e) => ({
    type: "expiry",
    ...e,
  })),
  ...hrActivities.map((a) => ({
    type: "activity",
    ...a,
  })),
].slice(0, 6);


  // Shortcuts definition (keeps parity with your HRPayrollDashboard shortcuts)
const SHORTCUTS = [
  {
    key: "attendance_overview",
    label: "Attendance Overview",
    value: "attendance_overview",
    path: isAdminUser ? "/hrpayroll/attendance" : "/hrpayroll/attendance-overview" ,
    icon: <FileTextOutlined />,
  },
  {
    key: "attendance_entry",
    label: "Attendance",
    value: "attendance_entry",
    path: "/hrpayroll/attendance",
    icon: <ScheduleOutlined />,
  },
  {
    key: "onboarding",
    label: "Onboarding",
    value: "onboarding",
    path: "/hrpayroll/onboarding",
    icon: <TeamOutlined />,
  },
  {
    key: "employee_entry",
    label: "Employees",
    value: "employee_entry",
    path: "/hrpayroll/employees",
    icon: <TeamOutlined />,
  },
  {
    key: "department_entry",
    label: "Departments",
    value: "department_entry",
    path: "/hrpayroll/departments",
    icon: <ApartmentOutlined />,
  },
  {
    key: "designation_entry",
    label: "Designations",
    value: "designation_entry",
    path: "/hrpayroll/designations",
    icon: <SolutionOutlined />,
  },
  {
    key: "clients_entry",
    label: "Clients",
    value: "clients_entry",
    path: "/hrpayroll/clients-entry",
    icon: <UserOutlined />,
  },
  {
    key: "salary_payment",
    label: "Salary Payments",
    value: "salary_payment",
    path: "/hrpayroll/salary-payments",
    icon: <DollarOutlined />,
  },
  {
    key: "hrlocation",
    label: "Branch Location",
    value: "hrlocation",
    path: "/hrpayroll/hrlocation",
    icon: <BankOutlined />,
  },
  {
    key: "salary_report",
    label: "Salary Payment Report",
    value: "salary_report",
    path: "/hrpayroll/salary-report",
    icon: <FileTextOutlined />,
  },
  {
    key: "monthly_salary_report",
    label: "Monthly Salary Report",
    value: "monthly_salary_report",
    path: "/hrpayroll/monthly-salary-report",
    icon: <FileTextOutlined />,
  },
  {
    key: "hr_settings_view",
    label: "HR Settings View",
    value: "hr_settings_view",
    path: "/hrpayroll/hr-settings-view",
    icon: <SettingOutlined />,
  },
];

const HR_KEYWORDS = ["employee", "department", "designation", "client", "status"];

  const filteredMenuData = SHORTCUTS.filter((menuItem) =>
    accessList.includes(menuItem.value)
  );

  // Top 5 shortcuts
  const attendanceDeprivedFilterMenuData = filteredMenuData?.filter(
    (el) => el.label !== "Attendance"
  );
  const topShortcuts =
    attendanceDeprivedFilterMenuData?.length > 5
      ? attendanceDeprivedFilterMenuData?.slice(0, 5)
      : attendanceDeprivedFilterMenuData;
  const topShortcutKeys = topShortcuts.map((s) => s.key);

  // compact card component
  const KpiCard = ({ title, value, subtitle, color }) => (
    <Card
      variant="borderless"
      style={{
        borderRadius: 12,
        minHeight: 96,
        background: color, // added background color
        color: "#fff",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Text style={{ color: "rgba(255,255,255,0.9)" }}>{title}</Text>
        <div style={{ fontSize: 28, fontWeight: 700, color: "#fff" }}>
          {value}
        </div>
        {subtitle && (
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.8)" }}>
            {subtitle}
          </div>
        )}
      </div>
    </Card>
  );

  // small notifications preview
  const NotificationPreview = () => (
  <Card
    title={
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <BellOutlined /> Notifications <Badge count={notificationsCount} />
      </div>
    }
    variant="borderless"
    style={{ borderRadius: 12 }}
    size="small"
  >
    {previewItems.length ? (
      <List
        dataSource={previewItems}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                <Avatar
                  icon={
                    item.type === "expiry" ? (
                      <FileTextOutlined />
                    ) : item.type === "activity" ? (
                      <UserOutlined />
                    ) : (
                      <ScheduleOutlined />
                    )
                  }
                />
              }
              title={<Text strong>{item.employee_name || item.activity_name}</Text>}
              description={
                <>
                  {/* Attendance */}
                  {item.status && (
                    <>
                      <div>Date: {dayjs(item.date).format("DD-MM-YYYY")}</div>
                      <div>Type: {item.type}</div>
                      <div>
                        Status:{" "}
                        <Tag
                          color={
                            item.status.toLowerCase().includes("awaiting")
                              ? "red"
                              : item.status.toLowerCase().includes("inprogress")
                              ? "orange"
                              : "green"
                          }
                        >
                          {item.status}
                        </Tag>
                      </div>
                    </>
                  )}

                  {/* Expiry */}
                  {item.days !== undefined && (
                    <Text type="secondary">
                      {item.label}: {item.days} days
                    </Text>
                  )}

                  {/* Activity */}
                  {item.created_date && (
                    <Text type="secondary">
                      {new Date(item.created_date).toLocaleString()}
                    </Text>
                  )}
                </>
              }
            />
          </List.Item>
        )}
      />
    ) : (
      <div style={{ textAlign: "center", padding: 12 }}>
        <Text type="secondary">No notifications</Text>
      </div>
    )}
  </Card>
);


  const openMark = async () => {
    if (userDeviceDetails.deviceType.toLowerCase() !== "mobile") {
      modal.error({
        title: "Device Alert",
        content: "You are only allowed to Mark attendance from the mobile app.",
      });
      return;
    }

    if (userDistance === null || isNaN(userDistance)) {
      modal.error({
        title: "Location Error",
        content:
          "Unable to determine your location. Please enable GPS and try again.",
      });
    } else if (userDistance <= 50) {
      setMarkModal(true);
      await dispatch(fetchcheckInStatus()).unwrap();
    } else {
      modal.error({
        title: "Location Alert",
        // content: `You are ${userDistance.toFixed(
        //   2
        content: `You are ${formatDistance(
          userDistance
        )} meters away from the office. You must be within 50 meters to mark attendance.`,
      });
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Title level={3} style={{ margin: 0 }}>
            HR & Payroll Dashboard
          </Title>
          <Text type="secondary">
            Compact view · {dayjs().format("DD MMM YYYY")}
          </Text>
        </Col>
        <Col className="hrDashboardTopHeaderContainer">
          <Space className="hrDashboardTopHeader">
            {isAdminUser && (
              <Button
                style={{ width: !screens.md && "100%" }}
                onClick={() => navigate("/hrpayroll/employees")}
              >
                Add Employee
              </Button>
            )}

            {isEmployee && (
              <Button
                style={{ width: !screens.md && "100%" }}
                type="primary"
                // onClick={openMark}
                onClick={() => navigate("/hrpayroll/attendance-overview?markAttendance=1")}
              >
                Mark Attendance
              </Button>
            )}

            <Dropdown
              style={{ width: !screens.md && "100%" }}
              className="hrDashboardShortcutBtn"
              menu={{
                items: filteredMenuData.map((s) => ({
                  key: s.key,
                  label: (
                    <Space>
                      {s.icon}
                      {s.label}
                    </Space>
                  ),
                  onClick: () => navigate(s.path),
                })),
              }}
              placement="bottomRight"
            >
              <Button style={{ width: !screens.md && "100%" }}>
                Shortcuts <DownOutlined />
              </Button>
            </Dropdown>
          </Space>
        </Col>
      </Row>

      {/* KPI Row */}
      {isAdminUser && (
        <Row gutter={[16, 16]} style={{ marginBottom: 18 }}>
          <Col xs={24} sm={12} md={6}>
            <KpiCard
              title="Total Employees"
              value={totalEmployees}
              subtitle="Active employees"
              color="linear-gradient(135deg, #1976d2, #64b5f6)"
            />
          </Col>

          <Col xs={24} sm={12} md={6}>
            <KpiCard
              title="Present Today"
              value={presentToday}
              subtitle="Checked-in employees"
              color="linear-gradient(135deg, #388e3c, #66bb6a)"
            />
          </Col>

          <Col xs={24} sm={12} md={6}>
            <KpiCard
              // title="Pending Leaves"
              title="On Leave Today"
              value={leaveToday}
              subtitle="Employees on approved leave"
              color="linear-gradient(135deg, #ef6c00, #ffa726)"
            />
          </Col>

          <Col xs={24} sm={12} md={6}>
            <KpiCard
              title="Pending Approvals"
              value={approvalsNeeded}
              subtitle="Attendance & leave requests"
              color="linear-gradient(135deg, #c62828, #ef5350)"
            />
          </Col>
        </Row>
      )}

      {/* <Col xs={24} sm={12} md={6}>
            <KpiCard
              title="Approvals Needed"
              value={approvalsNeeded}
              subtitle="Attendance & leave"
              color="linear-gradient(135deg, #c62828, #ef5350)"
            />
          </Col>
        </Row> */}
      {/* )} */}

      {/* Quick Shortcuts row */}
      <Card variant="borderless" style={{ borderRadius: 12, marginBottom: 18 }}>
        <div
          style={{
            display: "flex",
            gap: 12,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          {isEmployee && (
            <Button              
              // onClick={openMark}
              onClick={() => navigate("/hrpayroll/attendance-overview?markAttendance=1")}
              type="primary"
            >
              Mark Attendance
            </Button>
          )}
          {topShortcuts.map((s) => (
            <Button
              key={s.key}
              onClick={() => (navigate ? navigate(s.path) : null)}
              shape="round"
              size="middle"
            >
              <Space>
                <span style={{ fontSize: 16 }}>{s.icon}</span>
                <span>{s.label}</span>
              </Space>
            </Button>
          ))}
          <Dropdown
            menu={{
              items: attendanceDeprivedFilterMenuData
                .filter((s) => !topShortcutKeys.includes(s.key))
                .map((s) => ({
                  key: s.key,
                  label: (
                    <Space>
                      {s.icon}
                      {s.label}
                    </Space>
                  ),
                  onClick: () => navigate(s.path),
                })),
            }}
            placement="bottomLeft"
          >
            <Button shape="round">More</Button>
          </Dropdown>
        </div>
      </Card>

      {/* Main content: left (calendar + pending) / right (notifications + small lists) */}
      {isAdminUser && (
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={16}>
            {/* <Card variant="borderless" style={{ borderRadius: 12, marginBottom: 16 }}> */}
            {/* <Title level={5} style={{ marginBottom: 12 }}>Current Month Attendance Overview</Title> */}
            <AttendanceCharts
              attendanceReport={attendanceReport}
              employees={employees}
            />
            {/* </Card> */}

            <Divider />

            <Card variant="borderless" style={{ borderRadius: 12 }}>
              <Row gutter={[16, 16]}>
                <Col xs={24} md={8}>
                  <Title level={5}>Upcoming Expiries</Title>
                  <List
                    dataSource={upcomingExpiries.slice(0, 6)}
                    renderItem={(i) => (
                      <List.Item>
                        <List.Item.Meta
                          className="upcomingExpiries"
                          title={<Text strong>{i.employee_name}</Text>}
                          description={
                            <Text type="secondary">
                              {i.label}: {i.days} days
                            </Text>
                          }
                        />
                      </List.Item>
                    )}
                  />
                </Col>

                <Col xs={24} md={8}>
                  <Title level={5}>Recent Activities</Title>
                  <List
                    dataSource={hrActivities.slice(0, 6)}
                    renderItem={(i) => (
                      <List.Item>
                        <List.Item.Meta
                          title={<Text>{i.activity_name}</Text>}
                          description={
                            <Text type="secondary">
                              {new Date(i.created_date).toLocaleString()}
                            </Text>
                          }
                        />
                      </List.Item>
                    )}
                  />
                </Col>

                <Col xs={24} md={8}>
                  <Title level={5}>Quick Stats</Title>
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 8 }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text>Employees (by dept)</Text>
                      <Text strong>--</Text>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text>Avg Attendance</Text>
                      <Text strong>--</Text>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text>Leaves this month</Text>
                      <Text strong>--</Text>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <NotificationPreview />
            {/*
          <Divider />

           <Card variant="borderless" style={{ borderRadius: 12 }}>
            <Title level={5}>Shortcuts (compact)</Title>
            <List grid={{ gutter: 8, column: 1 }} dataSource={filteredMenuData} renderItem={(s) => (
              <List.Item>
                <Button block type="default" onClick={() => navigate ? navigate(s.path) : null} icon={s.icon}>{s.label}</Button>
              </List.Item>
            )} />
          </Card> */}
          </Col>
        </Row>
      )}

      <MarkAttendanceModal
        visible={markModal}
        onClose={() => setMarkModal(false)}
        onMarkAttendance={handleMarkAttendance}
        checkInTime={checkIndata?.check_in}
        checkOutTime={checkIndata?.check_out}
        isDisabled={disabled}
        userDistance={userDistance}
      />
    </div>
  );
}
